module.exports = __webpack_public_path__ + "img/produce-3.fef76d72.png";